import { handleError } from 'utilities/utilities';
import {
  AvlVerificationStatusType,
  IdentityVerificationResponse,
  VerificationStatusType,
} from 'utilities/verification/types';
import { getApiHost } from '../host-by-env';

export type VerificationResponseType = {
  result?: VerificationStatusType;
  data?: VerificationStatusType;
  errorCode: number | string;
};
export async function validatedCode(validationCode: string): Promise<VerificationResponseType> {
  const url = `${getApiHost()}cpl/verification/${validationCode}`;
  const response = await fetch(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  const json = await response.json();
  handleError(json);
  return json;
}

export type AvlVerificationResponseType = {
  result?: AvlVerificationStatusType;
  data?: AvlVerificationStatusType;
  errorCode: number | string;
};
export async function avlValidatedCode(validationCode: string): Promise<AvlVerificationResponseType> {
  const url = `${getApiHost()}firms/verify-avl/${validationCode?.trim()}`;
  const response = await fetch(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  const json = await response.json();
  handleError(json);
  return json;
}

export async function doIdentityVerification(
  tokenId: string,
  authToken: string,
): Promise<IdentityVerificationResponse> {
  const url = `${getApiHost()}marketplace/services/identity-verification/email/${tokenId}`;
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({ tokenId }),
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authToken}` },
  });
  const json = await response.json();
  handleError(json);
  return json.result;
}
